// The init command is re-exported from @shopify/create-app to reuse all the logic from there
export {default} from '@shopify/create-app/commands/init'
